import * as Sentry from '@sentry/electron/renderer'
import { createSnapshotConsumer } from '@highlight/ipc'
import { useSnapshotConsumer } from '@highlight/ipc/react'
import {
  EMPTY_OVERLAY_DISPLAY_SNAPSHOT,
  OVERLAY_DISPLAY_SNAPSHOT_TOPIC,
  type OverlayDisplaySnapshot,
  type OverlayNotchBounds,
} from '@shared/overlay-display-snapshot'

const overlayDisplayConsumer = createSnapshotConsumer<OverlayDisplaySnapshot>({
  topic: OVERLAY_DISPLAY_SNAPSHOT_TOPIC,
  initialSnapshot: EMPTY_OVERLAY_DISPLAY_SNAPSHOT,
  onError: (error) => {
    Sentry.captureException(error, { tags: { module: 'overlay-display-snapshot' } })
  },
})

export function useOverlayDisplaySnapshot(): OverlayDisplaySnapshot {
  return useSnapshotConsumer(overlayDisplayConsumer)
}

export function useOverlayNotchBounds(): OverlayNotchBounds | null {
  return useOverlayDisplaySnapshot().notchBounds
}

/** The overlay window covers the macOS menu bar; panel-like surfaces start below this inset. */
export function useOverlayMenuBarHeight(): number {
  return useOverlayDisplaySnapshot().menuBarHeight
}
